var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "OnboardingLayout",
    {
      attrs: {
        title: _vm.$t("onboarding.networks.title"),
        subtitle: _vm.$t("onboarding.networks.subtitle"),
        "can-proceed": _vm.canProceed,
      },
      on: { next: _vm.handleNext, skip: _vm.handleSkip },
    },
    [
      _c("NetworkSelector", {
        attrs: { networks: _vm.availableNetworks },
        model: {
          value: _vm.selectedNetworks,
          callback: function ($$v) {
            _vm.selectedNetworks = $$v
          },
          expression: "selectedNetworks",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }